import React, { useEffect, useState } from 'react'
import UserApi from '../../api/api-user'
import UserListDetail from '../../components/user/user-list-detail'
import { ReigniteDetailListUser } from '../../entities/ReigniteDetailListUser'

export default function UserAllPage(): React.ReactElement {
   return <UserListDetail />
}
